//The usePopup custom hook manages the state of whether the pop-up is open or closed, with openPopup and closePopup functions.
import { useState, useRef, useCallback } from "react";

const usePopover = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const openPopover = useCallback(() => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY, // Below the button
        left: rect.right + window.scrollX + 10, // Slightly to the right
      });
      setIsOpen(true);
    }
  }, []);

  const closePopover = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    position,
    openPopover,
    closePopover,
    triggerRef,
  };
};

export default usePopover;

